import React from 'react';
import { Link } from 'react-router-dom';
import { TrendingUp, Shield, Clock, Wallet, Target, Users, ChevronRight } from 'lucide-react';

const benefits = [
  { icon: TrendingUp, title: 'Business Stability', description: 'Predictable cash flow means you can plan and grow.' },
  { icon: Shield, title: '95% Certainty', description: 'Gazeal Agreements have the best success rate in the UK.' },
  { icon: Clock, title: 'Hours, Not Months', description: 'From request to payment in hours, not months.' },
  { icon: Wallet, title: 'Flexible Withdrawals', description: 'Choose how much to access. All, some, or none.' },
  { icon: Target, title: 'Reinvest in Growth', description: 'Use your commission to grow your business today.' },
  { icon: Users, title: 'Compete with Confidence', description: 'Operate freely knowing you can access earnings.' },
];

const WhyStabilitySection = () => {
  return (
    <section id="why-gazeal" className="relative py-10 md:py-14 bg-black overflow-hidden">
      <div className="relative z-10 max-w-[1200px] mx-auto px-6 lg:px-12">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold mb-2 heading">
            One Word: <span className="text-[#59d862]">Stability</span>
          </h2>
          <p className="text-white/55 text-sm md:text-base max-w-xl mx-auto">Cash flow kills businesses. Gazeal Advance exists to fix this.</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3 mb-8">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div key={index} className="p-4 bg-white/[0.02] border border-white/[0.05] rounded-2xl hover:bg-[#004048]/15 hover:border-[#59d862]/20 transition-all">
                <Icon className="w-6 h-6 text-[#59d862] mb-2" />
                <h3 className="text-base font-semibold text-white mb-1 heading">{benefit.title}</h3>
                <p className="text-white/55 text-sm leading-relaxed">{benefit.description}</p>
              </div>
            );
          })}  
        </div>

        <div className="p-5 md:p-8 bg-[#004048]/20 border border-[#59d862]/15 rounded-2xl">
          <div className="flex flex-col lg:flex-row items-center gap-6">
            <div className="flex-1">
              <blockquote className="text-base md:text-lg text-white/85 leading-relaxed mb-3">
                "Even just knowing you can do it takes a weight off. Our team breathes during the job more now."
              </blockquote>
              <div>
                <div className="text-white font-semibold text-sm">Sean Barrett</div>
                <div className="text-white/50 text-xs">Fine & Country, Agents Capital Founder</div>
              </div>
            </div>
            <div className="flex flex-col gap-2 w-full lg:w-auto">
              <Link to="/get-paid" className="btn-primary justify-center py-2.5 text-sm">Get Paid Now <ChevronRight className="w-4 h-4" /></Link>
              <Link to="/apply" className="btn-secondary justify-center py-2.5 text-sm">Apply to Join</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyStabilitySection;
